<template>
  <div>
    <NewCustomerPopup @newCustomer="loadAllCustomer"/>
    <!-- Your code here -->
    <div>
      <h1>Customers</h1>
      <ul>
        <li v-for="customer in customerList" :key="customer.id">
          {{ customer.name }}
          <ul>
            <li v-for="workshop in customer.workshop" :key="workshop.id" @click="openWorkshop(customer.id, workshop.id)">
              {{ workshop.name }}
            </li>
          </ul>
          <new-workshop-popup :customer-id="customer.id" :customer-name="customer.name" @newWorkshop="loadAllCustomer"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {loadCustomers, loadWorkshop} from "@/workshop/workshopFunctions";
import NewCustomerPopup from "@/components/NewCustomerPopup.vue";
import NewWorkshopPopup from "@/components/NewWorkshopPopup.vue";

export default {
  name: 'customerWorkshopSelection',
  components: {NewWorkshopPopup, NewCustomerPopup},
 // NAME is a predefined variable that will be replaced by the file name
  data() {
    return {
      // your data here
      customerList: []
    };
  },
  mounted() {
    this.loadAllCustomer();
  },
  methods: {
    loadAllCustomer(){
      loadCustomers().then(res => {
        if(res == null){
          return;
        }
        this.customerList = [... Object.values(res)];
      });
    },
    openWorkshop(customerId, workshopId){
      this.$store.dispatch('saveCustomerId', customerId);
      loadWorkshop(customerId, workshopId).then(res => {
        console.log(res)
        this.$store.commit('setWorkshopId', res.id);
        this.$router.push(`/customer/${customerId}/workshop/${res.id}`);
      });

    }
    // your methods here
  }
}
</script>

<style scoped>
/* your styles here */
</style>
